import React from 'react';
import store from '../store';
import { RESET_CITY,FILE_IMAGES } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AddIcon from '@material-ui/icons/Add';
import Dropzone from "react-dropzone";
import ExpandLessIcon from '@material-ui/icons//ExpandLess';
import { NotificationManager} from 'react-notifications';
import Fab from '@material-ui/core/Fab';
import Card from '@material-ui/core/Card';
import CardHeader  from '@material-ui/core/CardHeader';
import CardContent  from '@material-ui/core/CardContent';
import CardActions  from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import ReceiptIcon from '@material-ui/icons/Receipt';
import _ from 'lodash'
const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%',
    maxWidth: 680
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  }
});
var _this;
function matchYoutubeUrl(url) {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if(url.match(p)){
        return url.match(p)[1];
    }
    return false;
}
class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),
      open: false,
      image:null,
      deletedItems:[],
      heading:'',
      heading_price:0,
      showAddHeading:false,
      loading:false,
      size:'',
      size_price:0,
      showAddSize:false,
      flavoring:'',
      flavoring_price:0,
      showAddFlavor:false,
      strength:'',
      strength_price:0,
      showAddStrength:false,
      sweeteners:'',
      sweeteners_price:0,
      showAddSweet:false,
      extras:'',
      extras_price:0,
      showAddExtras:false,
      item_name:'',
      item_des:''


    }
    _this = this;
  }
  componentDidMount(props)
  {
    var item = this.state.item;
    if(item.image)
    {
      var image_preview = item.image;
      this.setState({image_preview});
    }
  }





  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;
    if(name=="order")
    {
      item[name] = parseInt(event.target.value?event.target.value:0);
    }
    else
    item[name] = event.target.value;

    _this.setState({ item });
  }
  handleStateChange = name => event => {
    event.preventDefault();

    //item[name] = event.target.value;

    _this.setState({ [name]: event.target.value});
  }



async  CreateItem  (data) {

    const item = data;

    //var check = window.confirm("Do you want to add category?");
    var _this=this;
    await _this.setState({loading:true});
          var docRef = firebase.firestore().collection("items").doc();
          for(let subitem of item.items)
          {
            let imageFile = subitem.file;
            if(subitem.file)
            {
              let filename=(new Date().getTime())+''+imageFile.name;
              var snap = await firebase.storage().ref().child('images/'+docRef.id+"/"+filename).put(imageFile);
              //console.log(snap);

                subitem.image = filename;
                 delete subitem["file"];
                subitem.preview=FILE_IMAGES+"images%2f"+docRef.id+"%2f"+filename+"?alt=media";

                //await firebase.firestore().collection("images").doc(item.id).update(item);
            }
          }
            docRef.set(item)
              .then(function () {

                item.id = docRef.id;
                item.order = item.order?parseInt(item.order):0;
                console.log(item);
                  //store.dispatch({ type: 'CREATE_DISTRICT', item });
                NotificationManager.success("Success!");
              //  _this.setState(RESET_CITY);
                _this.props.onClose();
              })
              .catch(function (error) {
                console.error(error);
                 _this.setState({loading:false});
              });






  }

  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;
await _this.setState({loading:true});
      const id = item.id;
      for(let subitem of item.items)
      {
        let imageFile = subitem.file;
        if(subitem.file)
        {
          let filename=(new Date().getTime())+''+imageFile.name;
          var snap = await firebase.storage().ref().child('images/'+id+"/"+filename).put(imageFile);
          //console.log(snap);

            subitem.image = filename;
             delete subitem["file"];
            subitem.preview=FILE_IMAGES+"images%2f"+id+"%2f"+filename+"?alt=media";

            //await firebase.firestore().collection("images").doc(item.id).update(item);
        }
      }
      for(let subitem of _this.state.deletedItems)
      {
        try {
          await firebase.storage().ref().child('images/'+id+"/" + subitem.image).delete();
        }
        catch(e){
          console.log(e);
        }
      }
      _this.setState({deletedItems:[]})
      firebase.firestore().collection("items").doc(id).update(item)
        .then(function () {
          item.id = id;
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.props.onClose();
        })
        .catch(function (error) {
          console.error(error);
           _this.setState({loading:false});
        });



  }
async  DeleteItem (id) {
    var check = window.confirm("Do you want to delete this item?");
    var _this=this;
    if (check === true) {
      await _this.setState({loading:true});
      const item = _this.state.item;
      for(let subitem of item.items)
      {
        if(subitem.image)
        {
          try {
            await firebase.storage().ref().child('images/'+id+"/" + subitem.image).delete();
          }
          catch(e){
            console.log(e);
          }
        }

      }
        firebase.firestore().collection("items").doc(id).set({archived:1}).then(()=>{
            NotificationManager.success("Success!");
            _this.props.onClose();
        });
    }

  }
  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };

addHeading = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.heading.push({name:this.state.heading,price:this.state.heading_price});
  //console.log(item.heading);
  _this.setState({ item,showAddHeading:false,heading:'',heading_price:0 });
}
addSize = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.size=item.size?item.size:[];
  item.size.push({name:this.state.size,price:this.state.size_price});
  //console.log(item.size);
  _this.setState({ item,showAddSize:false,size:'',size_price:0 });
}
addFlavor = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.flavoring=item.flavoring?item.flavoring:[];
  item.flavoring.push({name:this.state.flavoring,price:this.state.flavoring_price});
  //console.log(item.size);
  _this.setState({ item,showAddFlavor:false,flavoring:'',flavoring_price:0 });
}
addStrength = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.strength=item.strength?item.strength:[];
  item.strength.push({name:this.state.strength,price:this.state.strength_price});
  //console.log(item.size);
  _this.setState({ item,showAddStrength:false,strength:'',strength_price:0 });
}
addSweet = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.sweeteners=item.sweeteners?item.sweeteners:[];
  item.sweeteners.push({name:this.state.sweeteners,price:this.state.sweeteners_price});
  //console.log(item.size);
  _this.setState({ item,showAddSweet:false,sweeteners:'',sweeteners_price:0 });
}
addExtras = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.extras=item.extras?item.extras:[];
  item.extras.push({name:this.state.extras,price:this.state.extras_price});
  //console.log(item.size);
  _this.setState({ item,showAddExtras:false,extras:'',extras_price:0 });
}
addItem = event =>{
  event.preventDefault();
  const item = _this.state.item;
  item.items=item.items?item.items:[];
  item.items.push({name:this.state.item_name,des:this.state.item_des,file:this.state.image,preview:this.state.image_preview});
  //console.log(item.size);
  _this.setState({ item,item_name:'',item_des:'',image:null,image_preview:'',showAddItem:false });
}
removeItem = index =>event => {
  const item = _this.state.item;
  let deletedItems = _this.state.deletedItems;
  let removeItem = item.items[index];
  if(removeItem.image)
  {
    deletedItems.push(removeItem);
  }
  item.items.splice(index,1)
  _this.setState({item,deletedItems});

}


_onDrop(files) {
        console.log(files);
        if(files.length>0)
       this.setState({image_preview: files[0].preview,image:files[0]});
    }
  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,loading } = this.state;

    const isEnabled = !item ? false : item.title && item.order&&item.category&&!loading;
    return (<div>
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}>{this.state.item.id ? <EditIcon /> : <LocationOnIcon />}</Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}>{item.id ? 'Edit' : 'New'} Item</Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="body2" color="primary" style={{ marginBottom: 10 }}></Typography>
            <Divider style={{ marginBottom: 5 }} />
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.title}
                  onChange={this.handleChange('title')}
                  label="Title"
                  fullWidth
                  required
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>


            </Grid>
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.type}
                  onChange={this.handleChange('type')}
                  label="Type"
                  fullWidth
                  required
                  select

                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                <MenuItem value={0}>
              Meals
            </MenuItem>
            <MenuItem value={1}>
              Drinks
            </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
              <TextField
                value={item.order}
                onChange={this.handleChange('order')}
                label="Display Order"
                fullWidth
                required
                placeholder=""
                type="number"
                margin="normal"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>

            </Grid>
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.category}
                  onChange={this.handleChange('category')}
                  label="Category"
                  fullWidth

                  select

                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                {this.props.cats.filter(i=>i.type==item.type).map((c,index)=>{
                  return (<MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>)
                })}

                </TextField>
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
              <TextField
                value={item.price}
                onChange={this.handleChange('price')}
                label="Price"
                fullWidth
                required
                placeholder=""
                type="number"
                margin="normal"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>


            </Grid>
            {/*---------- Add Item List ----------*/}
            <Divider style={{marginTop:20,marginBottom:20}} />
            <h3 style={{margin:2}}>Item List <Fab onClick={()=>this.setState({showAddItem:!this.state.showAddItem})}  color="secondary"  size="small">
               {this.state.showAddItem?<ExpandLessIcon/>:<AddIcon />}
      </Fab></h3>

      {this.state.showAddItem?<Grid container>
        <Grid item xs style={{ margin: 5 }}>
        <div>Item Image (250x200 or 500x400)</div>
        <Dropzone onDrop={this._onDrop.bind(this)} accept="image/*" multiple={false} style={{display: 'flex', justifyContent: 'center', alignItems: 'center',width: '125px',height: '100px',borderWidth: '2px',borderColor: 'rgb(102, 102, 102)',borderStyle: 'solid',borderRadius: '5px'}} >
                {this.state.image_preview?<img id="imagePreview" alt="" src={this.state.image_preview ? this.state.image_preview : ''} style={{maxWidth:'100%',maxHeight:'100%'}} />:<ImageIcon style={{ fontSize: 60 }}/>}
              </Dropzone>

        </Grid>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.item_name}
          onChange={this.handleStateChange('item_name')}
          label="Item Name"
          fullWidth

          placeholder=""
          type="text"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>


      </Grid>:false}
      {this.state.showAddItem?<Grid container>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.item_des}
          onChange={this.handleStateChange('item_des')}
          label="Item Description(Optional)"
          fullWidth
          multiline={true}
          rows={3}
          rowsMax={6}
          placeholder=""
          type="text"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>
        <Grid item xs={12} >
        <Button style={{marginBottom:20}} onClick={this.addItem} disabled={!this.state.item_name||!this.state.image} size="small" variant="contained" color="primary">
           Add
      </Button>
        </Grid>

      </Grid>:false}


      <Grid container>

      <Grid item xs={12} >
      {item.items?item.items.map((i,index)=>{
        return (<Card key={index} style={{ marginBottom: 20 }}>
          <CardHeader
              avatar={<img src={i.preview} style={{width: '63px',height: '50px'}}/>}
              action={
                  <div style={{ marginTop: 6 }}>
                      <Hidden xsDown>
                          <IconButton aria-label="Remove" onClick={this.removeItem(index)} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                              <CloseIcon />
                          </IconButton>
                          </Hidden></div>}
              title={i.name}
              subheader={i.des}
          />
        <Hidden smUp>
            <CardActions className={classes.actions} disableActionSpacing>
              <IconButton aria-label="Remove" onClick={this.removeItem(index)}  style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                  <CloseIcon />
              </IconButton>

            </CardActions>
        </Hidden>
        </Card>);
      }):false}

      </Grid>
      </Grid>
            <Divider style={{marginTop:20,marginBottom:20}} />
            {item.type==1?<h3 style={{margin:2}}>Size <Fab onClick={()=>this.setState({showAddSize:!this.state.showAddSize})}  color="secondary"  size="small">
               {this.state.showAddSize?<ExpandLessIcon/>:<AddIcon />}
      </Fab></h3>:false}
      {item.type==1&&this.state.showAddSize?<Grid container>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.size}
          onChange={this.handleStateChange('size')}
          label="Name"
          fullWidth

          placeholder=""
          type="text"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.size_price}
          onChange={this.handleStateChange('size_price')}
          label="Price"
          fullWidth

          placeholder=""
          type="number"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>
        <Grid item xs={12} >
        <Button onClick={this.addSize} disabled={!this.state.size} size="small" variant="contained" color="primary">
           Add
      </Button>
        </Grid>


      </Grid>:false}
      {item.type==1?<Grid container>

        <Grid item xs={12} >
        {item.size.map((h,index)=>{
          return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.size.splice(index,1);this.forceUpdate();}} size="small">
            <CloseIcon style={{ marginRight: 5,color:'red' }} />
        </Button></p>)
        })}
        </Grid>
        </Grid>:false}
<Divider />

            <h3 style={{margin:2}}>{item.type==0?'Sauce':'Milk'} <Fab onClick={()=>this.setState({showAddHeading:!this.state.showAddHeading})}  color="secondary"  size="small">
               {this.state.showAddHeading?<ExpandLessIcon/>:<AddIcon />}
      </Fab></h3>
      {this.state.showAddHeading?<Grid container>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.heading}
          onChange={this.handleStateChange('heading')}
          label="Name"
          fullWidth

          placeholder=""
          type="text"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
          value={this.state.heading_price}
          onChange={this.handleStateChange('heading_price')}
          label="Price"
          fullWidth

          placeholder=""
          type="number"
          margin="normal"
          className={classes.textField}
          InputLabelProps={{
            shrink: true
          }}
        />


        </Grid>
        <Grid item xs={12} >
        <Button onClick={this.addHeading} disabled={!this.state.heading} size="small" variant="contained" color="primary">
           Add
  </Button>
        </Grid>


      </Grid>:false}
      <Grid container>

        <Grid item xs={12} >
        {item.heading.map((h,index)=>{
          return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.heading.splice(index,1);this.forceUpdate();}} size="small">
            <CloseIcon style={{ marginRight: 5,color:'red' }} />
        </Button></p>)
        })}
        </Grid>
        </Grid>


        <Divider />
        {item.type==0?<h3 style={{margin:2}}>Extras <Fab onClick={()=>this.setState({showAddExtras:!this.state.showAddExtras})}  color="secondary"  size="small">
           {this.state.showAddExtras?<ExpandLessIcon/>:<AddIcon />}
        </Fab></h3>:false}
        {item.type==0&&this.state.showAddExtras?<Grid container>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
        value={this.state.extras}
        onChange={this.handleStateChange('extras')}
        label="Name"
        fullWidth

        placeholder=""
        type="text"
        margin="normal"
        className={classes.textField}
        InputLabelProps={{
        shrink: true
        }}
        />


        </Grid>
        <Grid item xs style={{ margin: 5 }}>
        <TextField
        value={this.state.extras_price}
        onChange={this.handleStateChange('extras_price')}
        label="Price"
        fullWidth

        placeholder=""
        type="number"
        margin="normal"
        className={classes.textField}
        InputLabelProps={{
        shrink: true
        }}
        />


        </Grid>
        <Grid item xs={12} >
        <Button onClick={this.addExtras} disabled={!this.state.extras} size="small" variant="contained" color="primary">
        Add
        </Button>
        </Grid>


        </Grid>:false}
        {item.type==0?<Grid container>

        <Grid item xs={12} >
        {item.extras.map((h,index)=>{
        return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.extras.splice(index,1);this.forceUpdate();}} size="small">
        <CloseIcon style={{ marginRight: 5,color:'red' }} />
        </Button></p>)
        })}
        </Grid>
        </Grid>:false}


        <Divider />
        {item.type==1?<h3 style={{margin:2}}>Flavoring <Fab onClick={()=>this.setState({showAddFlavor:!this.state.showAddFlavor})}  color="secondary"  size="small">
           {this.state.showAddFlavor?<ExpandLessIcon/>:<AddIcon />}
  </Fab></h3>:false}
  {item.type==1&&this.state.showAddFlavor?<Grid container>
    <Grid item xs style={{ margin: 5 }}>
    <TextField
      value={this.state.flavoring}
      onChange={this.handleStateChange('flavoring')}
      label="Name"
      fullWidth

      placeholder=""
      type="text"
      margin="normal"
      className={classes.textField}
      InputLabelProps={{
        shrink: true
      }}
    />


    </Grid>
    <Grid item xs style={{ margin: 5 }}>
    <TextField
      value={this.state.flavoring_price}
      onChange={this.handleStateChange('flavoring_price')}
      label="Price"
      fullWidth

      placeholder=""
      type="number"
      margin="normal"
      className={classes.textField}
      InputLabelProps={{
        shrink: true
      }}
    />


    </Grid>
    <Grid item xs={12} >
    <Button onClick={this.addFlavor} disabled={!this.state.flavoring} size="small" variant="contained" color="primary">
       Add
  </Button>
    </Grid>


  </Grid>:false}
  {item.type==1?<Grid container>

    <Grid item xs={12} >
    {item.flavoring.map((h,index)=>{
      return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.flavoring.splice(index,1);this.forceUpdate();}} size="small">
        <CloseIcon style={{ marginRight: 5,color:'red' }} />
    </Button></p>)
    })}
    </Grid>
    </Grid>:false}

    <Divider />
    {item.type==1?<h3 style={{margin:2}}>Strength <Fab onClick={()=>this.setState({showAddStrength:!this.state.showAddStrength})}  color="secondary"  size="small">
       {this.state.showAddStrength?<ExpandLessIcon/>:<AddIcon />}
</Fab></h3>:false}
{item.type==1&&this.state.showAddStrength?<Grid container>
<Grid item xs style={{ margin: 5 }}>
<TextField
  value={this.state.strength}
  onChange={this.handleStateChange('strength')}
  label="Name"
  fullWidth

  placeholder=""
  type="text"
  margin="normal"
  className={classes.textField}
  InputLabelProps={{
    shrink: true
  }}
/>


</Grid>
<Grid item xs style={{ margin: 5 }}>
<TextField
  value={this.state.strength_price}
  onChange={this.handleStateChange('strength_price')}
  label="Price"
  fullWidth

  placeholder=""
  type="number"
  margin="normal"
  className={classes.textField}
  InputLabelProps={{
    shrink: true
  }}
/>


</Grid>
<Grid item xs={12} >
<Button onClick={this.addStrength} disabled={!this.state.strength} size="small" variant="contained" color="primary">
   Add
</Button>
</Grid>


</Grid>:false}
{item.type==1?<Grid container>

<Grid item xs={12} >
{item.strength.map((h,index)=>{
  return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.strength.splice(index,1);this.forceUpdate();}} size="small">
    <CloseIcon style={{ marginRight: 5,color:'red' }} />
</Button></p>)
})}
</Grid>
</Grid>:false}

<Divider />
{item.type==1?<h3 style={{margin:2}}>Sweeteners <Fab onClick={()=>this.setState({showAddSweet:!this.state.showAddSweet})}  color="secondary"  size="small">
   {this.state.showAddSweet?<ExpandLessIcon/>:<AddIcon />}
</Fab></h3>:false}
{item.type==1&&this.state.showAddSweet?<Grid container>
<Grid item xs style={{ margin: 5 }}>
<TextField
value={this.state.sweeteners}
onChange={this.handleStateChange('sweeteners')}
label="Name"
fullWidth

placeholder=""
type="text"
margin="normal"
className={classes.textField}
InputLabelProps={{
shrink: true
}}
/>


</Grid>
<Grid item xs style={{ margin: 5 }}>
<TextField
value={this.state.sweeteners_price}
onChange={this.handleStateChange('sweeteners_price')}
label="Price"
fullWidth

placeholder=""
type="number"
margin="normal"
className={classes.textField}
InputLabelProps={{
shrink: true
}}
/>


</Grid>
<Grid item xs={12} >
<Button onClick={this.addSweet} disabled={!this.state.sweeteners} size="small" variant="contained" color="primary">
Add
</Button>
</Grid>


</Grid>:false}
{item.type==1?<Grid container>

<Grid item xs={12} >
{item.sweeteners.map((h,index)=>{
return (<p style={{margin:2}} key={"heading"+index}>{h.name+" "+(h.price>0?"+"+h.price:h.price)} <Button onClick={()=>{item.sweeteners.splice(index,1);this.forceUpdate();}} size="small">
<CloseIcon style={{ marginRight: 5,color:'red' }} />
</Button></p>)
})}
</Grid>
</Grid>:false}






          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {!item.id ? '' : <Button onClick={()=>this.DeleteItem(item.id)} disabled={!isEnabled} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>}
            {!item.id ? <Button onClick={()=>this.CreateItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
              <SaveIcon style={{ marginRight: 5 }} />Create
          </Button> :
              <Button onClick={()=>this.SaveItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
                <SaveIcon style={{ marginRight: 5 }} />SAVE
        </Button>}
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
